import script from "./BrowseWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./BrowseWarehouse.vue?vue&type=style&index=0&id=c53930ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c53930ca"]])

export default __exports__